const convertToQueryString = (obj = {}) => {
  const object = { ...obj };

  Object
    .keys(obj)
    .forEach(key => !obj[key]
      && (obj[key] === null || obj[key] === undefined)
      && delete object[key]);

  const str = new URLSearchParams(object).toString();

  return str ? `?${str}` : str;
};

export default convertToQueryString;
